"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _resetAllLanguageSettingsChangesEpic = _interopRequireDefault(require("./resetAllLanguageSettingsChangesEpic"));

var _UpdateSitemapsSettings = _interopRequireDefault(require("../stagedObjects/UpdateSitemapsSettings"));

var _default = (0, _reduxObservable.combineEpics)(_resetAllLanguageSettingsChangesEpic.default, _UpdateSitemapsSettings.default.getResetChangesToStagedObjectEpic());

exports.default = _default;
module.exports = exports.default;